import { useEffect, type ReactElement } from 'react'
import { ErrorBoundary } from './components/ErrorBoundary.js'
import { DemoProvider } from './state/store.js'
import { useStep } from './state/useStep.js'
import { SCREENS } from './screens/registry.js'
import { STEPS } from './state/types.js'
import { usePreloadProofPhotos } from './lib/preload.js'
import { track } from './lib/analytics.js'

const TERMINAL_STEP = 'job-closed'

const Router = (): ReactElement | null => {
  const { step } = useStep()

  useEffect(() => {
    track('step_viewed', { step, index: STEPS.indexOf(step) })
    if (step === TERMINAL_STEP) track('demo_completed')
  }, [step])

  const Screen = SCREENS[step]
  return <Screen />
}

export const App = (): ReactElement => {
  usePreloadProofPhotos()
  return (
    <ErrorBoundary>
      <DemoProvider>
        <Router />
      </DemoProvider>
    </ErrorBoundary>
  )
}
